"use client";
import { Image } from "@/components/shared/image";
import { Zoom } from "@/components/ui/animations/zoom";
import { Shell } from "@/components/ui/shell";
import { convertKeysToCamelCase } from "@/lib/utils";
import {
  PersonalityProps,
  WallOfFameSectionProps,
} from "@/services/home/types";
import trophy from "public/assets/2025_Falcon_Trophy_4k.png";
import { Winners } from "./winners";

type Props = {
  data: WallOfFameSectionProps;
};

export default function WallOfFame({ data: res }: Readonly<Props>) {
  const data = convertKeysToCamelCase(res);
  const personalities = data.personalities?.map((x) =>
    convertKeysToCamelCase(x),
  ) as unknown as PersonalityProps[];

  return (
    <Shell>
      <div className="flex justify-center">
        <div className="flex flex-col items-center gap-8 lg:gap-20 2xl:flex-row">
          <div className="flex h-full flex-col-reverse items-center justify-start gap-10 lg:gap-14 xl:gap-20 2xl:flex-col">
            <div>
              <h1 className="text-center text-[40px] text-secondary sm:text-[50px] lg:text-[60px] xl:text-[70px] ltr:font-playfair">
                {data?.title}
              </h1>
              <p className="max-w-[518px] text-center text-lg leading-[34px] opacity-80 ltr:font-opensans">
                {data?.description}
              </p>
            </div>

            <Zoom duration={0.6} delay={0.2}>
              <Image
                src={trophy}
                width={55000}
                height={55000}
                priority
                alt="2024 trophy"
                draggable={false}
                className="w-[120px] md:w-[180px] xl:w-[200px]"
              />
            </Zoom>
          </div>
          <Winners data={personalities ?? []} />
        </div>
      </div>
    </Shell>
  );
}
